module.exports = __webpack_public_path__ + "img/webBrand--billy-dash-short.8cf3b954.svg";